import { useConfigState } from '../context/AppContext/AppContext';
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { CssBaseline, StyledEngineProvider, ThemeProvider, GlobalStyles } from "@mui/material";
import { ToastContainer } from 'react-toastify';
import { videojetConnectTheme } from "../Theme";
import { useMemo } from "react";
import { localeMap } from './LocalMap';
import { TemplatesProvider } from '../context/TemplateContext';
import { MiniSidebarProvider } from '../context/MiniSidebarContext';
import { ToolpadDashboardLayout } from './ToolpadDashboardLayout';


const globalDrawerStyles = {
  '.MuiDrawer-root': {
    '& .MuiDrawer-paper': {
      '& .MuiListItem-root': {
        fontSize: '16px',
        '&:hover': {
          backgroundColor: 'transparent !important',
        },
        '&.Mui-selected': {
          '&:hover': {
            backgroundColor: 'transparent !important',
          },
        },
      },
    }
  }
};

export const ToolpadLayout = () => {


  const { locale } = useConfigState();

  const gridTranslationsLocale = useMemo(() => {
    const localeItem = localeMap.find(x => x.id === locale);
    if (localeItem) {
      return localeItem.dateLocale ?? {};
    } else {
      console.log(`Locale ${locale} not found in localeMap`);
    }
    return {};
  }, [locale]);


  // Make sure MiniSidebarProvider wraps everything correctly
  return (
    <TemplatesProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={videojetConnectTheme(gridTranslationsLocale ?? {})}>
          <MiniSidebarProvider> {/* This should wrap everything */}
            <GlobalStyles styles={globalDrawerStyles} />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CssBaseline />
              <ToolpadDashboardLayout />
              <ToastContainer />
            </LocalizationProvider>
          </MiniSidebarProvider>
        </ThemeProvider>
      </StyledEngineProvider >
    </TemplatesProvider>
  );
}
